import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import runAnalysis from '../../actions/query-api/run-analysis';

import Checkbox from '../Checkbox'
import './style.css';

class FilterCheck extends Component {

  constructor(props){
    super(props);
    this.state = {
    	filterFundYears: this.props.filterFundYears,
    	filterFundSize: this.props.filterFundSize,
    }
    this.rerunAnalysis = this.rerunAnalysis.bind(this);
  }

  rerunAnalysis(){
  	this.setState({
  		filterFundYears: this.props.filterFundYears,
  		filterFundSize: this.props.filterFundSize
  	})
    this.props.setAwaitingNewData(true);
    this.props.runAnalysis();
  }

	render(){
		const changed = this.props.filterFundYears !== this.state.filterFundYears
			|| this.props.filterFundSize !== this.state.filterFundSize;
		return (<div className="filter-check">
			<div className="check-label">{this.props.TEXT.filterFundsByLabel}</div>
			<Checkbox 
				onChange={this.props.setFilterFundYears}
				value={this.props.filterFundYears}
				label=">3YRS" />
			<Checkbox 
				onChange={this.props.setFilterFundSize}
				value={this.props.filterFundSize}
				label=">$1B AUM" />
			<div className="filter-check-button">
        <button 
        	className={!changed && "disabled"}
        	onClick={() => { if(changed) this.rerunAnalysis() }}>
          {this.props.TEXT.rerunLabel}
        </button>
      </div>
		</div>)
	}
}

const mapStateToProps = createStructuredSelector({
  filterFundYears: state => state.entry.original.filterFundYears,
  filterFundSize: state => state.entry.original.filterFundSize,
  TEXT: state => state.complianceText,
});

const mapDispatchToProps = dispatch => ({
	setFilterFundYears: filterFundYears => dispatch({ type: "SET_FILTER_FUND_YEARS", value: filterFundYears }),
	setFilterFundSize: filterFundSize => dispatch({ type: "SET_FILTER_FUND_SIZE", value: filterFundSize }),
	setAwaitingNewData: value => dispatch({ type: "SET_AWAIT_STATUS", status: value }),
	runAnalysis: () => dispatch(runAnalysis()),
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterCheck);


// WEBPACK FOOTER //
// ./src/components/FilterCheck/index.js